export const API_URL = "https://norma.nomoreparties.space/api/ingredients"